module.exports = __webpack_public_path__ + "static/media/logo-big.d318aa7f.svg";